import { Button, Col, Form, Input, Modal, Row, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { onLoadChannel, onVerifyOAuth, onOk, onVerifyOAuthSuccess, onVerifyOAuthFailure } from './../../../actions/settingOAuthAction';
import Header from './../../../components/header';
import SideBar from './../../../components/sidebar-setting';
import { setHeight, titleHead } from './../../../services/helper';
import { permissions } from './../../../constants'
import handlePermission from './../../app/handlePermission';
import { ListChannel } from './../../../constants/setting_channel';
import './styles.css';
import history from '../../../services/history';
import { verifyOAuthCallback } from '../../../utils/settingOAuth';
import { listChannel } from '../../../utils/channel';
import axios from 'axios';
import { getApiHeader } from '../../../services/getApiHeaders';

class SettingOAuth extends Component {
    constructor(props) {
        super(props)
        this.state = {
            channel_id: '',
            disabled: !handlePermission(permissions.EcCredentialSaveSetting) ? true : false,
            currentChannel: ListChannel.AMAZON_JP.ShortName,
            currentChannelId: '',
        }
    }

    componentDidMount = () => {
        titleHead('OAuth')

        // Set the same height for three column
        setHeight()
        // Set the same height for three column when resize window
        window.addEventListener('resize', this.updateDimensions)

        let _this = this

        this.props.onVerifyOAuth();

        var channel_name = this.props.match.params.channel;
        if (ListChannel.AMAZON_JP.NameFileExportItemMaster.toLowerCase() === channel_name.toLowerCase()) {
            console.log(this.props.location);
            var spapi_oauth_code = new URLSearchParams(this.props.location.search).get("spapi_oauth_code")
            var selling_partner_id = new URLSearchParams(this.props.location.search).get("selling_partner_id")
            var mws_auth_token = new URLSearchParams(this.props.location.search).get("mws_auth_token")
            var state = new URLSearchParams(this.props.location.search).get("state")

            if (!state || !spapi_oauth_code) {
                this.props.onVerifyOAuthFailure();
            } else {
                var request = {
                    channel_id: 2,
                    spapi_oauth_code: spapi_oauth_code,
                    selling_partner_id,
                    mws_auth_token,
                    state
                }

                const json = verifyOAuthCallback(request)
                    .then(res => {
                        if (res.status === 200) {
                            if (res.data.code !== 10001) {
                                this.props.onVerifyOAuthFailure();
                            }else{
                                this.props.onVerifyOAuthSuccess();
                            }
                        } else {
                            this.props.onVerifyOAuthFailure();
                        }
                    }).catch(err => {
                        console.log(err);
                        this.props.onVerifyOAuthFailure();
                    });
            }
        } else {
            // TODO: unsupport oauth channel
            this.props.onVerifyOAuthFailure();
        }
    }

    okOnClick = (e) => {
        this.props.onOk();
        history.push('/setting/channel');
    }

    updateDimensions() {
        setHeight()
    }

    render() {
        return (
            <div id="setting-oauth">
                <Modal
                    visible={this.props.verify_success_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_verify_success" type="primary" onClick={this.okOnClick}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>Channel verified.</p>
                </Modal>
                <Modal
                    visible={this.props.verify_failure_visible}
                    closable={false}
                    footer={[
                        <Button key="ok_modal_verify_failure" type="primary" onClick={this.okOnClick}>
                            OK
                        </Button>,
                    ]}
                >
                    <p>Channel OAuth verify failed.<br></br><br></br>
                        Please check your channel account and try again.</p>
                </Modal>
                <Header />
                <div className="content">
                    <Row>
                        <Col id="setting-left" className="left-col" span={3}>
                            <SideBar />
                        </Col>
                        <Spin id="verify-spining" spinning={this.props.verifying} tip='Verifying...' />
                        <Col id="setting-center" className="center-col" span={9}>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        channel_id: state.settingOAuthReducer.channel_id,
        verifying: state.settingOAuthReducer.verifying,
        verify_success_visible: state.settingOAuthReducer.verify_success_visible,
        verify_failure_visible: state.settingOAuthReducer.verify_failure_visible,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onOk: () => {
            dispatch(onOk())
        },
        onLoadChannel: payload => {
            dispatch(onLoadChannel(payload))
        },
        onVerifyOAuth: payload => {
            dispatch(onVerifyOAuth(payload))
        },
        onVerifyOAuthSuccess: payload => {
            dispatch(onVerifyOAuthSuccess(payload))
        }
        ,
        onVerifyOAuthFailure: payload => {
            dispatch(onVerifyOAuthFailure(payload))
        }
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingOAuth)


// WEBPACK FOOTER //
// ./src/containers/setting/setting-oauth/index.js